import React from "react";

const InputRadioFake = ({ selected = true }) => (
  <div className={`input-radio-fake ${selected ? "sel" : ""}`}>
    {selected ? <div className="input-radio-fake-selected" /> : null}
  </div>
);

export default React.memo(InputRadioFake);
